export const URLS = {
	APP_ENV: import.meta.env.VITE_APP_ENV,
	WORKOUT: import.meta.env.VITE_WORKOUT_URL,
	CHAT: import.meta.env.VITE_CHAT_URL,
	MEDIA: import.meta.env.VITE_MEDIA_URL,
	KC_URL: import.meta.env.VITE_KC_URL,
	KC_REALM: import.meta.env.VITE_KC_REALM,
	KC_USER: import.meta.env.VITE_KC_USER,
	BUILD_TIME_MOSCOW: import.meta.env.VITE_BUILD_TIME_MOSCOW,
	GIT_COMMIT: import.meta.env.VITE_GIT_COMMIT,
	APP_VERSION: import.meta.env.VITE_APP_VERSION,
}
